var map = {
	"./industries/CORPORATE.webp": 414,
	"./industries/HOSPITALITY.webp": 9095,
	"./industries/Residential real estate.webp": 5783,
	"./industries/Student living.webp": 7399,
	"./product/OLT MOLT - XGSPON 16P.webp": 9034,
	"./product/OLT MOLT - XGSPON 8P.webp": 7661,
	"./product/OLT SOLT33- 08P.webp": 1834,
	"./product/OLT SOLT33-16P.webp": 9227,
	"./product/ONT P4200r.webp": 9413,
	"./product/ONT T2001.webp": 1354,
	"./product/ONT g2410.webp": 637,
	"./solution/Configurations and Personalized Support.webp": 5563,
	"./solution/Fibers Edge Over Copper.webp": 5767,
	"./solution/Optimized Fiber-Optic Solution.webp": 4654,
	"./solution/Scalable and Future-Ready Design.webp": 2131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7814;